import { useState, useEffect } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Avatar,
  Chip,
  Grid,
  Card,
  CardContent,
  Button,
  Pagination,
  Stack,
  Select,
  MenuItem,
  FormControl,
  CircularProgress,
  IconButton,
  Menu,
} from "@mui/material";
import {
  Settings,
  Menu as MenuIcon,
  Logout,
  Info,
  KeyboardArrowDown,
} from "@mui/icons-material";
import SupportPage from "../Buyer/Support";
import logo from "../Images/BizBridge-Logo-1.png";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentIcon from "@mui/icons-material/Payment";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import InventoryIcon from "@mui/icons-material/Inventory";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { fetchSellersList } from "../redux/slices/buyerNetworkSlice";

// ─── Theme ─────────────────────────────────────────────────────────────────
const theme = createTheme({
  palette: {
    primary: { main: "#0b2540" },
    secondary: { main: "#e7bf7a" },
    background: { default: "#f0f4f8", paper: "#ffffff" },
  },
  typography: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
    h4: { fontWeight: 800, letterSpacing: "-0.5px" },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 10 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 14, border: "1px solid #e2e8f0" },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#f8fafc",
          fontWeight: 700,
          fontSize: "0.72rem",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          color: "#94a3b8",
        },
        body: { fontSize: "0.875rem" },
      },
    },
  },
});

// ─── Sellers Data ──────────────────────────────────────────────────────────
// const allSellers = [
//   {
//     id: 1,
//     name: "Rajesh Kumar",
//     company: "Kumar Enterprises Pvt. Ltd.",
//     address: "Plot 14, Industrial Area Phase 2, Chandigarh, Punjab 160002",
//     avatar: "RK",
//     category: "Raw Materials",
//     status: "Active",
//     orders: 24,
//     pending: 3,
//   },
//   {
//     id: 2,
//     name: "Priya Mehta",
//     company: "Mehta Wholesale & Traders",
//     address: "Shop 7, Gandhi Market, Ahmedabad, Gujarat 380001",
//     avatar: "PM",
//     category: "Electronics",
//     status: "Active",
//     orders: 18,
//     pending: 1,
//   },
//   {
//     id: 3,
//     name: "Suresh Patel",
//     company: "Patel Global Supplies Co.",
//     address: "NH-8, Sector 18, Gurugram, Haryana 122015",
//     avatar: "SP",
//     category: "Machinery",
//     status: "Inactive",
//     orders: 9,
//     pending: 0,
//   },
//   {
//     id: 4,
//     name: "Anita Sharma",
//     company: "Sharma Trading House",
//     address: "MG Road, Block C, Indore, Madhya Pradesh 452001",
//     avatar: "AS",
//     category: "Textiles",
//     status: "Active",
//     orders: 31,
//     pending: 5,
//   },
//   {
//     id: 5,
//     name: "Mohammed Ismail",
//     company: "Ismail Brothers & Sons",
//     address: "Koti, Hyderabad, Telangana 500095",
//     avatar: "MI",
//     category: "Chemicals",
//     status: "Active",
//     orders: 15,
//     pending: 2,
//   },
//   {
//     id: 6,
//     name: "Kavita Joshi",
//     company: "Joshi Manufacturing Ltd.",
//     address: "Bhosari MIDC, Pune, Maharashtra 411026",
//     avatar: "KJ",
//     category: "FMCG",
//     status: "Active",
//     orders: 42,
//     pending: 7,
//   },
//   {
//     id: 7,
//     name: "Vikram Singh",
//     company: "Singh Industrial Corp.",
//     address: "Sector 22, Noida, Uttar Pradesh 201301",
//     avatar: "VS",
//     category: "Raw Materials",
//     status: "Active",
//     orders: 29,
//     pending: 4,
//   },
//   {
//     id: 8,
//     name: "Deepa Nair",
//     company: "Nair Global Exports",
//     address: "Edapally, Kochi, Kerala 682024",
//     avatar: "DN",
//     category: "Textiles",
//     status: "Inactive",
//     orders: 11,
//     pending: 0,
//   },
//   {
//     id: 9,
//     name: "Arjun Reddy",
//     company: "Reddy Agro Supplies",
//     address: "Begumpet, Hyderabad, Telangana 500016",
//     avatar: "AR",
//     category: "FMCG",
//     status: "Active",
//     orders: 36,
//     pending: 6,
//   },
//   {
//     id: 10,
//     name: "Sunita Verma",
//     company: "Verma Tech Solutions",
//     address: "Malviya Nagar, Jaipur, Rajasthan 302017",
//     avatar: "SV",
//     category: "Electronics",
//     status: "Active",
//     orders: 22,
//     pending: 2,
//   },
//   {
//     id: 11,
//     name: "Manish Gupta",
//     company: "Gupta Chemicals Ltd.",
//     address: "GIDC Estate, Vapi, Gujarat 396195",
//     avatar: "MG",
//     category: "Chemicals",
//     status: "Active",
//     orders: 17,
//     pending: 1,
//   },
//   {
//     id: 12,
//     name: "Rekha Pillai",
//     company: "Pillai Machinery Works",
//     address: "Peenya Industrial Area, Bengaluru, Karnataka 560058",
//     avatar: "RP",
//     category: "Machinery",
//     status: "Inactive",
//     orders: 8,
//     pending: 0,
//   },
// ];

// ─── Status Config ─────────────────────────────────────────────────────────
const statusConfig = {
  Active: { bg: "#d1fae5", color: "#065f46" },
  Inactive: { bg: "#f1f5f9", color: "#94a3b8" },
};

function Header() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);

  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "#fafbfc",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
        boxShadow: "0 2px 16px rgba(11,37,64,0.22)",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", px: { xs: 2, sm: 3.5 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2 }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              component="img"
              src={logo}
              sx={{
                height: 55,
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>

        {/* Clickable profile section - this opens the menu */}
        <Box
          onClick={handleProfileMenuOpen}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.2,
            background: "rgba(255,255,255,0.07)",
            border: "1px solid rgba(255,255,255,0.11)",
            borderRadius: "40px",
            px: 1.5,
            py: 0.6,
            cursor: "pointer",
            "&:hover": {
              background: "rgba(255,255,255,0.12)",
            },
          }}
        >
          <Avatar
            alt={user?.name}
            src={user?.profileImage?.url || "https://via.placeholder.com/60"}
            sx={{
              width: 48,
              height: 48,
              borderRadius: "50%",
              background: "#0b4064",
              color: "#fff",
              fontWeight: 700,
              fontSize: 16,
              flexShrink: 0,
              "& img": { borderRadius: "50%" },
            }}
          >
            {user?.name ? user.name.charAt(0).toUpperCase() : "U"}
          </Avatar>
          <Typography
            sx={{
              color: "#0b2540",
              fontSize: "0.85rem",
              fontWeight: 500,
              display: { xs: "none", sm: "block" },
            }}
          >
            {user?.name || "User"}
          </Typography>
          <KeyboardArrowDown
            sx={{
              color: "#0b2540",
              fontSize: 20,
              display: { xs: "none", sm: "block" },
            }}
          />
        </Box>

        {/* Profile Menu */}
        <Menu
          anchorEl={profileMenuAnchor}
          open={Boolean(profileMenuAnchor)}
          onClose={handleProfileMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            sx: {
              mt: 1,
              minWidth: 280,
              borderRadius: "14px",
              boxShadow: "0 12px 36px rgba(11,37,64,0.15)",
              border: "1px solid #e2e8f0",
              overflow: "visible",
              "&::before": {
                content: '""',
                position: "absolute",
                top: -6,
                right: 20,
                width: 12,
                height: 12,
                bgcolor: "#ffffff",
                borderLeft: "1px solid #e2e8f0",
                borderTop: "1px solid #e2e8f0",
                transform: "rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
        >
          {/* User Info Section */}
          <Box sx={{ p: 2, pb: 1 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Avatar
                alt={user?.name}
                src={
                  user?.profileImage?.url || "https://via.placeholder.com/60"
                }
                sx={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #0b4064, #1e6091)",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: 18,
                  flexShrink: 0,
                  border: "2px solid #e2e8f0",
                  "& img": { borderRadius: "50%" },
                }}
              >
                {user?.name ? user.name.charAt(0).toUpperCase() : "U"}
              </Avatar>
              <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
                <Typography
                  sx={{
                    fontSize: 15,
                    fontWeight: 700,
                    color: "#0b2540",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    mb: 0.3,
                  }}
                >
                  {user?.name || "User Name"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 13,
                    color: "#64748b",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    mb: 0.3,
                  }}
                >
                  {user?.businessName || "Business Name"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "#94a3b8",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {user?.email || "email@example.com"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Menu Items Section */}
          <Box sx={{ p: 1 }}>
            {/* Dashboard Link */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 0.5,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <StorefrontIcon
                sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }}
              />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                Dashboard
              </Typography>
            </MenuItem>

            {/* Orders Link */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard/orders");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 0.5,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <ReceiptLongIcon
                sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }}
              />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                My Orders
              </Typography>
            </MenuItem>

            {/* Cart Link */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard/cart");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 0.5,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <ShoppingCartIcon
                sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }}
              />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                Shopping Cart
              </Typography>
            </MenuItem>

            {/* Payments Link */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard/payments");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 0.5,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <PaymentIcon sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }} />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                Payments
              </Typography>
            </MenuItem>

            {/* Support Link */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard/support");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 1,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <SupportAgentIcon
                sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }}
              />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                Support
              </Typography>
            </MenuItem>

            {/* Divider */}
            <Box sx={{ borderTop: "1px solid #e2e8f0", my: 1 }} />

            {/* Settings */}
            <MenuItem
              onClick={() => {
                navigate("/buyer-dashboard/settings");
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                mb: 0.5,
                "&:hover": {
                  bgcolor: "#f8fafc",
                  "& .MuiTypography-root": { color: "#0b4064" },
                  "& svg": { color: "#0b4064" },
                },
              }}
            >
              <Settings sx={{ fontSize: 20, color: "#64748b", mr: 1.5 }} />
              <Typography fontSize="0.9rem" fontWeight={500} color="#0b2540">
                Settings
              </Typography>
            </MenuItem>

            {/* Logout */}
            <MenuItem
              onClick={() => {
                // Add logout logic here
                handleProfileMenuClose();
              }}
              sx={{
                borderRadius: "10px",
                py: 1.2,
                px: 2,
                "&:hover": {
                  bgcolor: "#fee2e2",
                  "& .MuiTypography-root": { color: "#dc2626" },
                  "& svg": { color: "#dc2626" },
                },
              }}
            >
              <Logout sx={{ fontSize: 20, color: "#ef4444", mr: 1.5 }} />
              <Typography fontSize="0.9rem" fontWeight={500} color="#ef4444">
                Logout
              </Typography>
            </MenuItem>
          </Box>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}

// ─── Seller Card ───────────────────────────────────────────────────────────
function SellerCard({ seller }) {
  const navigate = useNavigate();
  const sc = statusConfig[seller.status] || { bg: "#f1f5f9", color: "#94a3b8" };
  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        transition: "all 0.25s ease",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "3px",
          background: "linear-gradient(90deg, #0b4064, #2e9e53)",
          opacity: 0,
          transition: "opacity 0.25s",
        },
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 36px rgba(11,37,64,0.12)",
          borderColor: "#cbd5e1",
          "&::before": { opacity: 1 },
        },
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box
          sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2 }}
        >
          <Avatar
            sx={{
              width: 48,
              height: 48,
              background: "linear-gradient(135deg, #0b4064, #1e6091)",
              borderRadius: "12px",
              fontSize: "0.88rem",
              fontWeight: 700,
              flexShrink: 0,
            }}
          >
            {seller.avatar}
          </Avatar>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              fontWeight={700}
              fontSize="0.98rem"
              color="#0f172a"
              noWrap
            >
              {seller.company}
            </Typography>
            <Typography
              fontSize="0.8rem"
              color="#475569"
              fontWeight={500}
              noWrap
            >
              {seller.name}
            </Typography>
          </Box>
          <Box
            sx={{
              px: 1.2,
              py: 0.3,
              borderRadius: "20px",
              background: sc.bg,
              color: sc.color,
              fontSize: "0.7rem",
              fontWeight: 700,
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
          >
            {seller.status}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
            bgcolor: "#f8fafc",
            borderRadius: "10px",
            p: 1.2,
            mb: 1.5,
          }}
        >
          <LocationOnOutlinedIcon
            sx={{ fontSize: 16, color: "#94a3b8", mt: 0.2, flexShrink: 0 }}
          />
          <Typography fontSize="0.78rem" color="#64748b" lineHeight={1.5}>
            {seller.address}
          </Typography>
        </Box>
        <Box sx={{ mb: 1.5 }}>
          <Chip
            icon={<CategoryOutlinedIcon sx={{ fontSize: "13px !important" }} />}
            label={seller.category}
            size="small"
            sx={{
              bgcolor: "#eff6ff",
              color: "#1d4ed8",
              fontWeight: 600,
              fontSize: "0.7rem",
              height: 22,
            }}
          />
        </Box>
        <Grid container spacing={1.2} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <Box
              sx={{
                bgcolor: "#f8fafc",
                borderRadius: "10px",
                p: 1.2,
                textAlign: "center",
              }}
            >
              <Typography fontWeight={700} fontSize="1.2rem" color="#0b2540">
                {seller.orders}
              </Typography>
              <Typography fontSize="0.68rem" color="#94a3b8" mt={0.3}>
                Total Orders
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              sx={{
                bgcolor: "#f8fafc",
                borderRadius: "10px",
                p: 1.2,
                textAlign: "center",
              }}
            >
              <Typography
                fontWeight={700}
                fontSize="1.2rem"
                color={seller.pending > 0 ? "#ef4444" : "#0b2540"}
              >
                {seller.pending}
              </Typography>
              <Typography fontSize="0.68rem" color="#94a3b8" mt={0.3}>
                Pending
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Button
          fullWidth
          variant="contained"
          onClick={() => navigate("/buyer-dashboard/view-products")}
          sx={{
            bgcolor: "#0b2540",
            "&:hover": {
              bgcolor: "#0b4064",
              transform: "translateY(-1px)",
              boxShadow: "0 6px 16px rgba(11,37,64,0.28)",
            },
            py: 1.2,
            fontSize: "0.875rem",
            transition: "all 0.2s",
          }}
        >
          View
        </Button>
      </CardContent>
    </Card>
  );
}

// ─── Root ──────────────────────────────────────────────────────────────────
export default function BuyerDealersDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedSeller, setSelectedSeller] = useState(null);
  // const [activeTab, setActiveTab] = useState("catalog");
  const { sellers, loading, totalSellers } = useSelector((state) => state.buyerNetwork);

  useEffect(() => {
    dispatch(fetchSellersList({ page: 1, limit: 10 }));
  }, [dispatch]);

  // ── Pagination state — matches ManageOrders exactly ──────────────────────
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [paginationLoading, setPaginationLoading] = useState(false);

  const handlePageChange = (event, value) => {
    setPage(value);
    setPaginationLoading(true);
    // Replace body with:
      dispatch(fetchSellersList({ page: value, limit }))
        .then(() => setPaginationLoading(false))
        .catch(() => setPaginationLoading(false));
    setTimeout(() => {
      fetchSellersList(value, limit);
      setPaginationLoading(false);
    }, 300);
  };

  // ── Limit change handler — identical pattern to ManageOrders ─────────────
  const handleLimitChange = (event) => {
    const newLimit = event.target.value;
    setLimit(newLimit);
    setPage(1); // reset to first page when limit changes
    // Replace with: dispatch(getBuyerSellers({ page: 1, limit: newLimit }))
    fetchSellersList(1, newLimit);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: "background.default", minHeight: "100vh" }}>
        <Header />
        <Box
          sx={{
            px: { xs: 1, sm: 1.5, md: 2 },
            py: { xs: 1, sm: 1 },
            maxWidth: "100%",
            mx: 0,
          }}
        >
          {/* ── Seller Grid ─────────────────────────────────────────────── */}
          {!selectedSeller && (
            <>
              {/* Page header + limit selector */}
              <Box
                sx={{
                  mb: { xs: 1.5, md: 2.5 },
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1,
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "#0b2540",
                      fontFamily: "'Archivo Black', sans-serif",
                    }}
                  >
                    Seller Network
                  </Typography>
                  <Typography
                    fontSize="0.875rem"
                    color="#64748b"
                    mt={0.5}
                    sx={{ fontFamily: "'DM Sans', sans-serif" }}
                  >
                    Browse and manage your connected sellers&nbsp;·&nbsp;
                    <Box component="span" fontWeight={700} color="#0b2540">
                      {totalSellers} sellers
                    </Box>
                  </Typography>
                </Box>

                {/* Limit dropdown — */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    fontSize="0.8rem"
                    color="#64748b"
                    fontWeight={500}
                  >
                    Show
                  </Typography>
                  <FormControl size="small">
                    <Select
                      value={limit}
                      onChange={handleLimitChange}
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        borderRadius: "10px",
                        color: "#0b2540",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e2e8f0",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#94a3b8",
                        },
                        height: 36,
                        minWidth: 64,
                      }}
                    >
                      {[3, 6, 9, 12].map((n) => (
                        <MenuItem
                          key={n}
                          value={n}
                          sx={{ fontSize: "0.8rem", fontWeight: 600 }}
                        >
                          {n}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <Typography
                    fontSize="0.8rem"
                    color="#64748b"
                    fontWeight={500}
                  >
                    per page
                  </Typography>
                </Box>
              </Box>

              {/* Cards grid */}
              <Box sx={{ position: "relative" }}>
                {paginationLoading && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      bgcolor: "rgba(255,255,255,0.6)",
                      zIndex: 10,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "14px",
                    }}
                  >
                    <CircularProgress size={36} sx={{ color: "#0b2540" }} />
                  </Box>
                )}
                <Grid container spacing={2.5}>
                  {sellers.map((seller) => (
                    <Grid item xs={12} sm={6} md={4} key={seller.id}>
                      <SellerCard seller={seller} />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              {/* ── Pagination footer —  */}
              <Box
                sx={{
                  mt: 4,
                  mb: 2,
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  borderTop: "1px solid #e2e8f0",
                  px: 10,
                  py: 2,
                }}
              >
                {/* "Showing X–Y of Z" info text */}
                <Typography fontSize="0.82rem" color="#64748b" fontWeight={500}>
                  Showing{" "}
                  <Box component="span" fontWeight={700} color="#0b2540">
                    {(page - 1) * limit + 1}–
                    {Math.min(page * limit, totalSellers)}
                  </Box>{" "}
                  of{" "}
                  <Box component="span" fontWeight={700} color="#0b2540">
                    {totalSellers}
                  </Box>{" "}
                  sellers
                </Typography>

                {/* MUI Pagination — same props as ManageOrders handlePageChange */}
                <Stack spacing={2}>
                  <Pagination
                    count={"totalPages"}
                    page={page}
                    onChange={handlePageChange}
                    shape="rounded"
                    siblingCount={1}
                    boundaryCount={1}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        borderRadius: "10px",
                        fontWeight: 600,
                        color: "#475569",
                        border: "1px solid #e2e8f0",
                        "&:hover": {
                          bgcolor: "#eff6ff",
                          borderColor: "#bfdbfe",
                          color: "#1d4ed8",
                        },
                      },
                      "& .MuiPaginationItem-root.Mui-selected": {
                        bgcolor: "#0b2540",
                        color: "#fff",
                        borderColor: "#0b2540",
                        "&:hover": { bgcolor: "#0b4064" },
                      },
                    }}
                  />
                </Stack>
              </Box>
            </>
          )}

          {/* ── Seller Detail ────────────────────────────────────────────── */}
          {selectedSeller && (
            <>
              <Box sx={{ mb: { xs: 1.5, md: 2 } }}>
                <Typography
                  variant="h4"
                  sx={{
                    color: "#0b2540",
                    fontFamily: "'Syne', 'DM Sans', sans-serif",
                  }}
                >
                  Seller Details
                </Typography>
                <Typography fontSize="0.875rem" color="#64748b" mt={0.5}>
                  Viewing: {selectedSeller.company}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  bgcolor: "#fff",
                  borderRadius: "14px",
                  border: "1px solid #e2e8f0",
                  overflow: "hidden",
                  minHeight: { xs: "unset", md: 600 },
                  boxShadow: "0 4px 24px rgba(11,37,64,0.08)",
                }}
              ></Box>
            </>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
